import React, { useEffect, useMemo } from 'react';
import { MultiSelect } from 'primereact/multiselect';
import { Dropdown } from 'primereact/dropdown';
import { Button } from 'primereact/button';
import { useSelector, useDispatch } from 'react-redux';

import { getAllDCListInit, setSelectedDCList } from './redux/actions';

const SearchDCInput = ({
    handleClick,
    showButton = true,
    placeholder = "Select a distribution center from dropdown",
    disabled = false,
    singleSelect = false
}) => {
    const DCList = useSelector(state => state.searchDC.DCList);
    const selectedDCList = useSelector(state => state.searchDC.selectedDCList);
    const dispatch = useDispatch();

    useEffect(() => {
        if (!DCList?.length) dispatch(getAllDCListInit());
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    const dcOptions = useMemo(() =>
        (DCList || []).map(dc => ({ ...dc, label: `${dc.name} (${dc.code})` })),
        [DCList]
    );

    const handleMultiChange = (e) => dispatch(setSelectedDCList(e.value || []));

    const handleSingleChange = (e) => dispatch(setSelectedDCList(e.value ? [e.value] : []));

    return (
        <div className="search-dc-input-container">
            <div className="search">
                {singleSelect ? (
                    <Dropdown
                        className="sc-multiselect w-100"
                        value={selectedDCList?.[0] ?? null}
                        options={dcOptions}
                        optionLabel="label"
                        onChange={handleSingleChange}
                        placeholder={placeholder}
                        disabled={disabled}
                        filter
                        filterBy="label"
                        showClear
                    />
                ) : (
                    <MultiSelect
                        className="sc-multiselect w-100"
                        value={selectedDCList}
                        options={dcOptions}
                        optionLabel="label"
                        onChange={handleMultiChange}
                        placeholder={placeholder}
                        disabled={disabled}
                        filter
                        filterBy="label"
                        display="chip"
                        showClear
                    />
                )}
                {showButton && (
                    <Button
                        label="Search"
                        icon="pi pi-search"
                        onClick={handleClick}
                        className="sc-search-btn filter-button p-button-outlined p-button-sm"
                    />
                )}
            </div>
        </div>
    );
};

export default SearchDCInput;